import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const IrelandFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15021'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15021)'>
				<rect
					x='13.334'
					width='6.66667'
					height='14'
					fill='#FF8515'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H6.66667V0H0V14Z'
					fill='#07BB59'
				/>
			</g>
		</svg>
	);
};

export default IrelandFlagIcon;
